import React, { Component } from 'react';
import CardWidget from "../../components/Widgets/Card/CardWidgets";
import TableWidgets from 'components/Widgets/Table/TableWidgets';
import ChartWidgets from '../../components/Widgets/Charts/ChartWidgets';

class DataBindingComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bindList: "",
            data: "",
            timerObj : {},
        }
    }
    
    componentDidMount() {
        if (this.props.widgetItem.dataFrom === "URL") {
            let bindValues = this.props.widgetItem.bind;
            if (bindValues.callbackFlag) {
                this.executeLiveRefresh(bindValues);
                if(bindValues.timeInterval !==  "Nil"){
                    var timerIds =  setInterval(() => {
                        this.executeLiveRefresh(bindValues);
                        this.setState({
                            timerObj : timerIds
                        })
                    }, parseInt(bindValues.timeInterval) * 1000);
                }
            }
        }
    }

    componentWillUnmount(){
        clearInterval(this.state.timerObj);
    }

    executeLiveRefresh = (bindValues) => {
        var obj = new Function("return " + bindValues.callbackObj)(); // here convert to callback function to proper function statement
        Promise.all([this.getBindData(this.props.widgetItem, obj)]).then(values => {
            this.props._onChangeValueData(this.props.updateIndex, values);
        })
    }



    getBindData = async (bindData, callback) => {
        if (bindData !== undefined) {
            let bindValues = bindData.bind;
            try {
                let requestUrl = bindValues.apiUrl;
                let requestPayload = {};
                if (bindValues.queryParam !== "" && bindValues.queryParam !== null && bindValues.queryParam !== undefined) {
                        requestUrl = bindValues.apiUrl + "?" + bindValues.queryParam;
                }
                if (bindValues.methodType === "POST") {
                    requestPayload = JSON.parse(bindValues.payload)
                }
                var headersInject = {};

                if(bindValues.headers !== ""){
                    try {
                        var parseHeader = JSON.parse(bindValues.headers);
                        headersInject = parseHeader;
                    } catch (err) {
                        headersInject = {};
                    }
                }else{
                    headersInject = {};
                }
                const response = await fetch(requestUrl,
                    {
                        method: bindValues.methodType,
                        headers: headersInject
                    },
                    requestPayload);
                const responseData = await response.json();
                return callback(responseData);
            } catch (error) {
                return console.warn(error);
            }
        }
    }

    renderChart = () => {
        if (this.props.widgetItem.widgetType === "Pie" || this.props.widgetItem.widgetType === "Bar" || this.props.widgetItem.widgetType === "Doughnut" ||
        this.props.widgetItem.widgetType === "Column" || this.props.widgetItem.widgetType === "Line" || this.props.widgetItem.widgetType === "Spline" || this.props.widgetItem.widgetType === "Area") {
        if (this.props.widgetItem.bind.hasOwnProperty('data') && this.props.widgetItem.bind.data !== null && this.props.widgetItem.bind.data !== "") {
            return <ChartWidgets
                widgetItem={this.props.widgetItem}
            />
        }
    }
    }

    render() {
        return (
            <>
                {this.props.widgetItem.widgetType === "Card" &&
                    <CardWidget
                        widgetItem={this.props.widgetItem}
                    />
                }

                {/* here chart rendering option added */}
                {this.renderChart()}

                {this.props.widgetItem.widgetType === "Table" &&
                    <TableWidgets widgetItem={this.props.widgetItem} />
                }

            </>
        )
    }
}


export default DataBindingComponent;